define("settings/routes/subscription/billing", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/routing/route", "@ember/runloop", "@ember/service", "ember-concurrency"], function (_exports, _asyncArrowRuntime, _route, _runloop, _service, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/routing/route",0,"@ember/runloop",0,"@ember/service",0,"ember-concurrency"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let BillingRoute = _exports.default = (_class = class BillingRoute extends _route.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "address", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "payment", _descriptor4, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor5, this);
      _defineProperty(this, "handleEmailReceiptsToggle", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (account) {
          const isEnabling = !account.emailReceipts;
          const messageStr = isEnabling ? 'message_enable' : 'message_disable';
          account.toggleProperty('emailReceipts');
          try {
            yield account.save();
            this.alerts.success(this.intl.t(`alerts.account.subscription.billing.email_receipt.success.${messageStr}`), {
              title: this.intl.t('alerts.account.subscription.billing.email_receipt.success.title')
            });
          } catch (error) {
            (0, _runloop.later)(() => {
              account.rollbackAttributes();
            }, 10);
            this.alerts.warning(this.intl.t('alerts.generic_error_message'), {
              title: this.intl.t('alerts.account.subscription.billing.email_receipt.error.title')
            });
          }
        }
      }), null, "handleEmailReceiptsToggle", "drop"));
    }
    async beforeModel() {
      if (this.subscriptions.isEnterpriseSubscription) return;
      await Promise.allSettled([this.address.setup.perform(), this.payment.retrieve.perform()]);

      // Note: card accessed in controller via getter
      const creditCard = await this.payment.retrieveCard.perform();
      this.address.setSelectedCountryIfNew(creditCard?.card?.country);
    }
    setupController(controller) {
      controller.setProperties({
        handleEmailReceiptsToggle: this.handleEmailReceiptsToggle,
        didAddNewCard: false
      });
      controller.setupEvents();
    }
    resetController(controller) {
      controller.teardownEvents();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
});